import React from 'react'
import { Banner, Flex, Icon, Span, Text } from '@sendoutcards/quantum-design-ui'
import { useMarketingParagraphById } from 'src/react_query'

export const MarketingParagraphBanner = (props: { id: string }) => {
  const { data: paragraphData } = useMarketingParagraphById(
    { id: props.id },
    { suspense: true },
  )
  const paragraph = paragraphData!.paragraph

  return (
    <Banner status={'success'}>
      <Flex justifyContent="flex-start" alignItems="center" width="100%">
        <Span display="flex" justifyContent="center" alignContent="center">
          <Icon
            name="exclamation"
            primaryColor="primaryBodyText"
            size="small"
          />
        </Span>
        <Text type="body">{paragraph.content} </Text>
      </Flex>
    </Banner>
  )
}
